export default __webpack_public_path__ + "static/media/produto-vinho-animacao.60ea0a22.gif";